module.exports = __webpack_public_path__ + "img/survey2.e5a7d56e.png";